import { Directive, Input,  OnInit } from '@angular/core';
import { AbstractControl, AsyncValidator, NG_ASYNC_VALIDATORS, ValidationErrors } from '@angular/forms';
import { SharedDataService } from '../Services/shared-data/shared-data.service';
import { SuppliersService } from '../Services/suppliers.service';
import { Observable } from 'rxjs';
import {  map } from 'rxjs/operators';
import { SearchSuppliersParameters } from '../Models/SearchSuppliersParameters';
import { PS_Search_Suppliers_Result } from '../Models/PS_Search_Suppliers_Result';


@Directive({
  selector: '[dunsUnique]',
  providers: [{
    provide: NG_ASYNC_VALIDATORS, useExisting: DunsUniqueDirective, multi:
      true
  }]
})
export class DunsUniqueDirective  implements AsyncValidator,OnInit {

  constructor(private suppliersSvc:SuppliersService,private sharedDatasSvc:SharedDataService) { }
  private msg:string;
  @Input() dunsUnique?:any = null;
  ngOnInit(): void {
    this.sharedDatasSvc.getLabel('Duns_deja_reference_pour_le_fournisseur',null,null).subscribe(res=>this.msg=res);
  }
  
  validate(control: AbstractControl): Promise<ValidationErrors> | Observable<ValidationErrors> {
    if ((control.value||'null')=='null') return null;
    let parameters : SearchSuppliersParameters = new SearchSuppliersParameters();
    parameters.UniqueId = (<string>control.value).trim();
    return this.suppliersSvc.getSuppliers(parameters)
    .pipe(map((result:PS_Search_Suppliers_Result[])=>{
      result = result.filter(r=>r.Id!=(<number>this.dunsUnique||0));
      if (result && result.length>0) {
        let error: any = result[0];
        let msg2:string=this.msg.replace('&1',result[0].SupplierName);
        error.toString=function(){
          return msg2;
        }
        return {'dunsUnique': error};
        
      } else {
        return null;
      }
    }));
  }
  registerOnValidatorChange?(fn: () => void): void {
    
  }

}
